import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { type ReactNode } from 'react';

export interface DataListRowProps {
  label: ReactNode;
  value: ReactNode;
}

const DataListRow = ({ label, value }: DataListRowProps) => {
  return (
    <>
      <Text appearance={TokenTextAppearance.copy200} bold>
        {label}
      </Text>
      <Text appearance={TokenTextAppearance.copy200}>{value}</Text>
    </>
  );
};

export default DataListRow;
